import { Alert, Collapse } from "@mui/material";
import * as React from "react";
import { CloseCircleOutlined } from "@ant-design/icons";

const ErrorPopup = ({ children }) => {
  const [open, setOpen] = React.useState(true);

  return (
    <Collapse in={open}>
      <Alert
        severity="error"
        action={
          <CloseCircleOutlined
            onClick={() => {
              setOpen(false);
            }}
          ></CloseCircleOutlined>
        }
      >
        {children}
      </Alert>
    </Collapse>
  );
};

export default ErrorPopup;
